module.exports = __webpack_public_path__ + "fonts/font.95240c1.woff2";